import { useQuery } from '@tanstack/react-query';

import type { ChargerFlow, ChargerFlowsResponse } from '@models/chargerFlows';

import { getAllChargerFlows, getChargerFlowById } from './api';

export function useAllChargerFlows(page: number) {
  return useQuery<ChargerFlowsResponse>({
    queryKey: ['allChargerFlows', page],
    queryFn: () => getAllChargerFlows(page),
  });
}

export function useChargerFlows(flowId: string) {
  return useQuery<ChargerFlow>({
    queryKey: ['chargerFlows', flowId],
    queryFn: () => getChargerFlowById(flowId),
  });
}
